import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'

// COMPONENTS
import AppBar from '../components/app-bar/AppBar'
import LoginForm from '../components/app-form/LoginForm'
import { withSnackbar } from 'notistack'
import { translate, Trans } from 'react-i18next'

const styles = theme => ({
  container: {
    height: '100vh',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
  },
  content: {
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
  },
})

class Login extends Component {
  state = {
    isFetching: false,
    error: '',
    refJoin: window.state.refJoin,
  }

  handleSubmit = values => {
    this.setState({
      isFetching: true,
    })

    const url = '/login'

    const options = values => ({
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
      body: JSON.stringify(values),
    })

    const errors = response => {
      this.setState({
        isFetching: false,
        error: response.errors.password.join(),
      })
    }

    function handleResponse(response) {
      return response.json().then(res => {
        if (response.status >= 200 && response.status < 300) {
          return res
        } else {
          throw res
        }
      })
    }

    fetch(url, options(values))
      .then(handleResponse)
      .then(data => {
        location.href = '/dashboard'
      })
      .catch(errors)
  }

  render() {
    const { classes } = this.props

    return (
      <section className={classes.container}>
        <AppBar hideLogin={true} />

        <main className={classes.content}>
          <div
            style={{
              fontSize: 24,
              maxWidth: 510,
              textAlign: 'center',
              marginBottom: 72,
            }}
          >
            <Trans i18nKey="login.title">Вход в кабинет ROMI center</Trans>
          </div>
          <LoginForm
            onSubmit={this.handleSubmit}
            isFetching={this.state.isFetching}
            errorLogin={this.state.error}
            refJoin={this.state.refJoin}
          />
        </main>
      </section>
    )
  }
}

export default withStyles(styles)(withSnackbar(translate('common')(Login)))
